<template>
  <div class="basis-full text-center sm:basis-6/12 lg:basis-4/12">
    <div
      class="te-bg-first-sidejob-webdesign-banner-image relative h-full rounded bg-cover bg-center"
      style="flex: 1"
    >
      <TeCourseSetBannerBadgeTwo />
      <a
        class="co-bg-hover-trans-black-20 flex h-full text-center text-white hover:bg-co-gray-950/20 hover:text-white"
        href="/set/first-sidejob-webdesign"
      >
        <div class="mx-auto p-4">
          <img
            class="mx-auto mb-3 md:mb-4"
            src="~/assets/images/Te/TeCourse/SetBanner/FirstSidejobWebdesign/set-icon-first-sidejob-webdesign.svg"
            loading="lazy"
            alt="はじめての副業+Webデザインセット"
            width="94"
            height="49"
          >
          <h3
            class="co-display-11 mb-3 w-full font-bold tracking-[.15em]"
            style="line-height: 1.5"
          >
            <span
              v-for="(title, index) in trackTitles"
              :key="index"
            >
              {{ title }}
            </span>
          </h3>
          <p class="co-display-14 mb-2 border-b pb-3">
            デザインとコーディングをまとめて学び副業も始められるお得なセット
          </p>
          <p class="co-display-13 tracking-[.15em]">
            申込締切
            <ClientOnly>
              <span class="co-display-9 pl-2 pr-1 font-bold">{{ yesterdayMonth(closesAt) }}</span>月
              <span class="co-display-9 pr-1 font-bold">{{ yesterdayDays(closesAt) }}</span>日（{{ yesterdayDayOfWeek(closesAt) }}）{{ hours(closesAt) }}時
            </ClientOnly>
          </p>
        </div>
      </a>
    </div>
  </div>
</template>

<script lang="ts">
import { getPack } from '~/utility/fetchAPI'
import { dateToYesterday, daysOfWeek } from '~/utility/utility'
import TeCourseSetBannerBadgeTwo from '~/components/Te/TeCourse/SetBanner/Badge/TeCourseSetBannerBadgeTwo.vue'

interface Pack {
  attributes: {
    closes_at: string
    track_title: string
  }
}

const options = {
  data() {
    return {
      pack: null as Pack | null,
    }
  },
  methods: {
    hours(date: string): number {
      return new Date(date).getHours() + 24
    },
    yesterdayDays(date: string): number {
      return dateToYesterday(new Date(date)).getDate()
    },
    yesterdayMonth(date: string): number {
      return dateToYesterday(new Date(date)).getMonth() + 1
    },
    yesterdayDayOfWeek(date: string): '日' | '月' | '火' | '水' | '木' | '金' | '土' {
      const yesterday = dateToYesterday(new Date(date))
      const dayOfWeek = daysOfWeek(yesterday)
      return dayOfWeek
    },
  },
  mounted() {
    getPack(this.$api, 'first-sidejob-webdesign-set').then((response) => {
      this.pack = response.data
    })
  },
  computed: {
    closesAt(): Date | null {
      if (!this.pack) {
        return null
      } else {
        return new Date(this.pack.attributes.closes_at)
      }
    },
    yesterdayClosesAt(): Date | null {
      return this.closesAt ? dateToYesterday(this.closesAt) : null
    },
    closesDays(): number | '-' {
      return this.yesterdayClosesAt ? this.yesterdayClosesAt.getDate() : '-'
    },
    closesMonth(): number | '-' {
      return this.yesterdayClosesAt
        ? this.yesterdayClosesAt.getMonth() + 1
        : '-'
    },
    closesHours(): number | '-' {
      return this.yesterdayClosesAt
        ? this.yesterdayClosesAt.getHours() + 24
        : '-'
    },
    closesDayOfWeek(): '日' | '月' | '火' | '水' | '木' | '金' | '土' | '-' {
      return this.yesterdayClosesAt ? daysOfWeek(this.yesterdayClosesAt) : '-'
    },
    trackTitles(): string[] {
      return this.pack ? this.pack.attributes.track_title.split('+') : ['-']
    },
  },
  components: {
    TeCourseSetBannerBadgeTwo,
  },
}

export default defineComponent(options)
</script>

<style scoped>
.te-bg-first-sidejob-webdesign-banner-image {
  background-image: url('~/assets/images/Te/TeCourse/SetBanner/FirstSidejobWebdesign/cover-first-sidejob-webdesign-set-s.webp');
}
</style>
